import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";

export const About = ({ t }) => (
  <section id="about" className="py-28 bg-[#111A2E] relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="lg:col-span-7"
      >
        <p className="text-xs tracking-[0.35em] uppercase font-mono text-[#E2C376] mb-5 flex items-center gap-3">
          <span className="w-10 h-px bg-[#D4AF37]" /> {t.about.eyebrow}
        </p>
        <h2 data-testid="about-section-heading" className="font-serif text-2xl sm:text-3xl lg:text-4xl text-slate-50 tracking-tight mb-8 max-w-lg">
          {t.about.title}
        </h2>
        <p className="text-base text-slate-300 leading-relaxed mb-5 max-w-xl">{t.about.p1}</p>
        <p className="text-base text-slate-400 leading-relaxed max-w-xl">{t.about.p2}</p>

        <div data-testid="about-accreditation-badge" className="mt-10 inline-flex items-center gap-3 border border-[#D4AF37]/30 px-5 py-3 rounded-sm">
          <BadgeCheck className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.4} />
          <span className="text-sm text-[#E2C376] font-mono tracking-wide">IDE/UID CHE-113.947.145</span>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.15 }}
        className="lg:col-span-5"
      >
        <div className="relative">
          <img
            src="https://images.unsplash.com/photo-1625902045351-b4157224e18b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
            alt="Swiss office"
            className="w-full h-72 object-cover opacity-80"
          />
          <div data-testid="about-heritage-card" className="bg-[#0A101D] border border-[#D4AF37]/20 p-8 -mt-10 relative mx-6">
            <h3 className="font-serif text-xl text-amber-200/90 mb-6">{t.about.card_title}</h3>
            <dl className="space-y-4 text-sm">
              <div className="flex justify-between border-b border-[#D4AF37]/10 pb-3">
                <dt className="text-slate-500 font-mono text-xs uppercase tracking-widest">{t.about.founded}</dt>
                <dd className="text-slate-200">2007</dd>
              </div>
              <div className="flex justify-between border-b border-[#D4AF37]/10 pb-3">
                <dt className="text-slate-500 font-mono text-xs uppercase tracking-widest">{t.about.seat}</dt>
                <dd className="text-slate-200 text-right">Route de Champ-Colin 12<br />1260 Nyon</dd>
              </div>
              <div className="flex justify-between border-b border-[#D4AF37]/10 pb-3">
                <dt className="text-slate-500 font-mono text-xs uppercase tracking-widest">N° féd.</dt>
                <dd className="text-slate-200">CH-660.2.847.007-6</dd>
              </div>
              <div className="flex justify-between gap-6">
                <dt className="text-slate-500 font-mono text-xs uppercase tracking-widest shrink-0">{t.about.activity}</dt>
                <dd className="text-slate-200 text-right">{t.about.activity_val}</dd>
              </div>
            </dl>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);
